<template>
    <div :class="`c-a-status c-a-status--${status}`">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props: [ 'status' ]
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/AtomStatus.vue